export default "__VITE_ASSET__BPZ9kUjB__"